import React from 'react'

const AppleAssoc = () => {
  const appleJson = {
    "applinks": {
      "details": [
        {
          "appIDs": ["MCL79X83GJ.com.miazgabyfitmatkawariatka"],
          "components": [
            {
              "#": "no_universal_links",
              "exclude": true,
              "comment":
                "Matches any URL whose fragment equals no_universal_links and instructs the system not to open it as a universal link",
            },
          ],
        },
      ],
    },
    "webcredentials": {
      "apps": ["MCL79X83GJ.com.miazgabyfitmatkawariatka"],
    },
    "appclips": {
      "apps": [],
    },
  }

  setTimeout(() => {
    document.getElementById('json').innerHTML = JSON.stringify(
      appleJson,
      undefined,
      2
    )
  }, 500)

  return <pre id="json">


  </pre>
}

export default AppleAssoc
